import {useTranslation} from "react-i18next";
import {i18n} from "@i18n/i18n";

type Vars = Record<string, any>;

export function useProjectTranslations() {
    return useTranslation("project");
}

export function usePublicTranslations() {
    return useTranslation("public");
}

export function publicTranslator(key: string, vars?: Vars) {
    return i18n.t(key, {ns: "public", ...vars});
}

export function projectTranslator(key: string, vars?: Vars) {
    return i18n.t(key, {ns: "project", ...vars});
}
